import {EvidenceData} from '../../data/evidence';
import * as constants from './_styles';

const CreativeData = EvidenceData[2].content;

const CreativeSection = props => {

  return (

    CreativeData.map((item, i) => {
      return (
        <constants.WorkContainer key={i}>
          <constants.ImageContainer bgImage={props.bgImage || item.image}/>
          <constants.DataContainer>
            <constants.Label>{item.client || 'Client'}</constants.Label>
            <h3>{item.project || 'Project Name'}</h3><constants.LabelType>{item.product || 'Product'}</constants.LabelType>
            <p>{item.intro || 'Description of project.'}</p>
            <constants.ActivityContainer>
              {
                item.activity.map((item, i) => {
                  return (
                    <ul key={i}>
                      <li>{item || 'Activities'}</li>
                    </ul>
                  );
                })
              }
            </constants.ActivityContainer>
          </constants.DataContainer>
        </constants.WorkContainer>
      );
    })
  );
};

export default CreativeSection;
